import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { StorageModel, Storage} from './../../models/storage.model';


@Component({
  selector: 'app-modal-storage',
  templateUrl: './modal-storage.component.html',
  styles: []
})
export class ModalStorageComponent implements OnInit {

  storage : Storage;

  formControl = new FormControl('');
  modalForm : FormGroup;
  selectedFile : File;

  //Manipulamos la clase modal
  private _storageModel = new StorageModel;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) { }

  ngOnInit() {
        this.modalForm = this.fb.group({
          clave: [this.storage ? this.storage.clave : null],
          nombre: [this.storage ? this.storage.nombre : null],
          posesion: [this.storage ? this.storage.posesion : null],
          proveedor: [this.storage ? this.storage.proveedor : null],
          fechaCompra: [this.storage ? this.storage.fechaCompra : null],
          total: [this.storage ? this.storage.total : null],
          factura: [this.storage ? this.storage.factura : ""],
          imagen: [this.storage ? this.storage.imagen : ""],
          descripcion: [this.storage ? this.storage.descripcion : ""],
        });
  }

  onFileSelected(event){
    this.selectedFile = event.target.files[0];
  }

  //Agregar dominio
  adminStorage(){
    this.activeModal.close('Guardado datos');
    this._storageModel.createStorage(this.modalForm.value);
  }

}
